module.exports = __webpack_public_path__ + "static/media/11.final.7b2fd5b8.mp4";